const capitalizeFirstChar = prop => {
  if (typeof prop !== 'string' && !prop.length) return 'N/A'
  return prop.charAt(0).toUpperCase() + prop.slice(1)
}

export default { capitalizeFirstChar }